import './nosotros.scss';
import './scroll-into-view';
import './vertical-tabs-nosotros';
import '../../js/form-init';
import '../../js/form-select';
import '../../js/dropdown-menu';
import '../../js/floating-header';
import '../../js/mobile-tabs';
import '../../js/nav-row';
import '../../js/scroll-animation';
import '../../js/lazy-load';
import '../../js/lazy-load-recaptcha';
import '../../js/lottie';
import '../../js/footer-current-year';
import { scrollToContactForm } from '../../js/scroll-to-contact';


// We want an animation scroll from the the top of the page
// to the contact section to occur.
window.addEventListener('load', function() {
  window.addEventListener('hashchange', scrollToContactForm);
  scrollToContactForm();
});

$('.nosotros-is-contact-link').click(scrollToContactForm);